/* eslint-disable */
import React, { useEffect, useState, useCallback, useContext } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { CircularProgress,Box } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { getTechSessionUpdatedDetails, techSessionRequestApi } from '../../../Api/request/techSessions';
import ButtonComponent from "../../../Components/Button/button";
import { RECIEVE_REQUEST, SIGNUP_TECH_SESSION } from '../../../Constants/strings';
import BACK_BUTTON from '../../../Assets/images/svg/dar_back_arrow.svg';
import CommonTextField from '../../../Components/TextField/textField';
import CommonDatePicker from '../../../Components/Datepicker/datepicker';
import TimePicker from '../../../Components/TimePicker/timePicker';
import SearchDropdown from '../../../Components/Dropdown/dropdown';
import UseAxios from '../../../Api/http/http';
import dayjs from 'dayjs';
import ActionConfirmationDialog from '../ReceivedRequest/actionConfirmationDialog';
import { AuthContext } from "../../../Contexts/AuthContext";
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import { fetchDepartmentList, fetchVertivalList } from '../../SkillMap/apiCallUtil';
import { TextField, Autocomplete, Checkbox } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { updateLoginDetails } from '../../../Utils/userSession';


// Reusable style for disabled MUI input backgrounds
const disabledInputBgSx = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#f5f5f5',
    '&.Mui-disabled': { backgroundColor: '#f5f5f5' },
  },
};
const disabledDropdownBgCss = {
  '& .MuiSelect-select.Mui-disabled': {
    backgroundColor: '#f5f5f5 !important',
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#f5f5f5',
  },
};
const departmentFieldSx = {
  ...disabledInputBgSx,
  '& .MuiOutlinedInput-root': {
    ...disabledInputBgSx['& .MuiOutlinedInput-root'],
    minHeight: '40px', // Set fixed height
    '& .MuiAutocomplete-inputRoot': {
      paddingTop: '0px',
      paddingBottom: '0px',
    },
  },
};

const ApproveRejectForm = ({ sessionId }) => {
  const navigate = useNavigate();
  const { snackbarOpen } = useSnackbar();
  const { userProfile } = useContext(AuthContext);
  const [sessionData, setSessionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { control, reset } = useForm({ defaultValues: {} });
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [buttonText, setButtonText] = useState('');
  const [comments, setComments] = useState('');
  const [canApproveReject, setCanApproveReject] = useState(false);
  const [isApprove, setIsApprove] = useState(false);
  const [departmentList, setDepartmentList] = useState([]);
  const [verticalList, setVerticalList] = useState([]);

   useEffect(() => {
    fetchDepartmentList().then(setDepartmentList);
    fetchVertivalList().then(setVerticalList);
  }, []);

  useEffect(() => {
    const fetchSession = async () => {
      try {
        const response = await UseAxios(getTechSessionUpdatedDetails(sessionId));
        const details = response?.data?.data?.techSessionDetails?.[0];
        if (details) {
        let audienceData = [{ verticalId: null, departmentId: [] }];
        
        if (details.deptVerDetails && Array.isArray(details.deptVerDetails) && details.deptVerDetails.length > 0) {
          audienceData = details.deptVerDetails.map(item => {
            const vertical = { id: item.verticalId, name: item.verticalName };
            const departments = item.departmentList || [];

            return {
              verticalId: vertical,
              departmentId: departments
            };
          });
        }

          const mappedData = {
            id: details.id,
            sessionName: details.sessionName || "",
            sessionType: details.sessionType || "",
            topic: details.sessionTopic || "",
            hostName: details.hostName || "",
            hostEmail: details.hostEmail || "",
            creatorEmail: details.creatorEmail || "",
            coHost: details.coHostNames || [],
            coHostEmail: details.coHostEmail || [],
            date: details.sessionDate ? dayjs(details.sessionDate) : null,
            startTime: details.startTime ? dayjs(details.startTime, "HH:mm") : null,
            endTime: details.endTime ? dayjs(details.endTime, "HH:mm") : null,
            location: details.location || "",
            audience: audienceData,
            description: details.description || "",
            status: details.status || "",
            isApproved: details.isApproved || "",
          };
          setSessionData(mappedData);
          reset(mappedData);

          if (userProfile) {
            const loggedInEmail = userProfile.email?.toLowerCase();

            const hostEmail = mappedData.hostEmail?.toLowerCase();
            const isHost = loggedInEmail === hostEmail;

            const isNewRequest =
              mappedData.status === "New Request" || mappedData.isApproved === "New Request" || mappedData.isApproved === "Update Requested" || mappedData.isApproved === "Update Confirmed";

            setCanApproveReject(isHost && isNewRequest);
          }
        } else {
          setSessionData(null);
          reset({});
          snackbarOpen("No session found for the given ID.", 'error');
        }
      } catch (err) {
        console.error("Error fetching session:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSession();
    localStorage.removeItem('redirectAfterLogin');
  }, [sessionId, reset, userProfile]);


  const handleApprove = useCallback(() => {
    setIsDialogOpen(true);
    setIsApprove(true);
    setTitle("Approve request");
    setDescription("Are you sure you want to approve the request?");
    setButtonText("Approve");
  }, []);

  const handleReject = useCallback(() => {
    setIsDialogOpen(true);
    setIsApprove(false);
    setTitle("Reject request");
    setDescription("Are you sure you want to reject the request?");
    setButtonText("Reject");
  }, []);

  const onPopupCancel = () => {
    setIsDialogOpen(false);
    setComments("");
  };

  const approveOrRejectTechSession = useCallback(() => {
    const payload = {
      sessionId: sessionId,
      comments: comments,
      isApproved: isApprove,
      isInvited: true,
      lastUpdatedBy: userProfile.user_name,
      employeeId: userProfile.employeeId,
      type: 'Host',
    };
    setIsDialogOpen(false);

    UseAxios(techSessionRequestApi(payload))
      .then((response) => {
        if (response?.status === 200) {
          navigate('/tech-session/received-request');
          snackbarOpen(
            isApprove
              ? RECIEVE_REQUEST?.SESSION_UPDATE_REQUEST_APPROVED
              : RECIEVE_REQUEST?.SESSION_UPDATE_REQUEST_REJECTED,
            'success'
          );
          setComments('');
        } else {
          snackbarOpen(
            isApprove
              ? RECIEVE_REQUEST?.API_ERROR_FOR_APPROVE
              : RECIEVE_REQUEST?.API_ERROR_FOR_REJECT,
            'error'
          );
        }
      })
      .catch((error) => {
        if (error?.statusCode === 403) {
          const token = localStorage.getItem('authToken');
          updateLoginDetails(token).then(() => {
            snackbarOpen('Token expired. Please login again.', 'error');
          });
        }
        snackbarOpen(
          isApprove
            ? RECIEVE_REQUEST?.API_ERROR_FOR_APPROVE
            : RECIEVE_REQUEST?.API_ERROR_FOR_REJECT,
          'error'
        );
      });
  }, [
    sessionId,
    comments,
    isApprove,
    userProfile,
    snackbarOpen,
    RECIEVE_REQUEST,
  ]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="deal-transition-master-outer-layer-a">
      <div className="deal-transition-master-map-title">
        <button
          type="button"
          className="deal-transition-master-back-button"
          onClick={() => navigate("/tech-session/received-request")}
        >
          <img src={BACK_BUTTON} alt="back icon" className="back-icon" />
        </button>
        {'View Updated Details'}
      </div>
      <div className="sign-up-tech-session-form">
        <form>
          <label className="sign-up-tech-session-label">
            {SIGNUP_TECH_SESSION.FIELDS.HOST_NAME}
          </label>
          <Controller
            name="hostName"
            control={control}
            render={({ field }) => (
              <CommonTextField
                {...field}
                disabled
                size="small"
                sx={disabledInputBgSx}
              />
            )}
          />

          <label className="sign-up-tech-session-label-other">
            {SIGNUP_TECH_SESSION.FIELDS.SESSION_NAME}
          </label>
          <Controller
            name="sessionName"
            control={control}
            render={({ field }) => (
              <CommonTextField
                {...field}
                disabled
                size="small"
                sx={disabledInputBgSx}
              />
            )}
          />

          <label className="sign-up-tech-session-label-other">
            {SIGNUP_TECH_SESSION.FIELDS.TOPIC}
          </label>
          <Controller
            name="topic"
            control={control}
            render={({ field }) => (
              <CommonTextField
                {...field}
                disabled
                size="small"
                sx={disabledInputBgSx}
              />
            )}
          />
          <label className="sign-up-tech-session-label-other" style={{ marginBottom: '-20px' }}>
            {SIGNUP_TECH_SESSION.FIELDS.ADD_HOST}
          </label>
          <Controller
            name="coHost"
            control={control}
            render={({ field }) => (
              <SearchDropdown
                {...field}
                disabled
                options={[]}
                value={Array.isArray(field.value) ? field.value.join(", ") : field.value}
                customCss={disabledDropdownBgCss}
              />
            )}
          />

          <label className="sign-up-tech-session-label-other" style={{ marginBottom: '-1px' }}>
            {SIGNUP_TECH_SESSION.FIELDS.SESSION_DATE}
          </label>
          <Controller
            name="date"
            control={control}
            render={({ field }) => (
              <CommonDatePicker
                {...field}
                isDisabled={true}
                displayFormat="DD MMM, YYYY"
                sx={disabledInputBgSx}
              />
            )}
          />

          <label className="sign-up-tech-session-label-other" style={{ marginBottom: '2px' }}>
            {SIGNUP_TECH_SESSION.FIELDS.START_TIME}
          </label>
          <div className="sign-up-tech-session-time-slots">
            <Controller
              name="startTime"
              control={control}
              render={({ field }) => (
                <TimePicker
                  {...field}
                  isDisabled={true}
                  sx={disabledInputBgSx}
                />
              )}
            />
            <Controller
              name="endTime"
              control={control}
              render={({ field }) => (
                <TimePicker
                  {...field}
                  isDisabled={true}
                  sx={disabledInputBgSx}
                />
              )}
            />
          </div>

           <label className="sign-up-tech-session-label-other">{SIGNUP_TECH_SESSION.FIELDS.SELECT_AUDIENCE}</label>
          <Controller
            name="audience"
            control={control}
            render={({ field }) => {
              const { value } = field;
              const audienceArray = Array.isArray(value) ? value : [{ verticalId: null, departmentId: [] }];

              return (
                <>
                  {audienceArray.map((row, index) => (
                    <Box
                      key={index}
                      className="sign-up-tech-session-audience-row"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        position: 'relative',
                        mb: 2,
                      }}
                    >
                      {/* Vertical Dropdown - Read Only */}
                      <Box sx={{ flex: 1 }}>
                        <Autocomplete
                          disabled
                          popupIcon={<KeyboardArrowDownIcon className="audience-vertical-dropdown-icon" />}
                          disableClearable
                          options={[]}
                          value={row.verticalId || null}
                          getOptionLabel={(option) => option?.name || ''}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              disabled
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                sx: disabledInputBgSx['& .MuiOutlinedInput-root'],
                              }}
                              className="audience-vertical-textfield custom-placeholder-style"
                            />
                          )}
                          className="audience-vertical-autocomplete"
                        />
                      </Box>

                      {/* Department Dropdown - Read Only */}
                      <Box sx={{ flex: 1 }} className="audience-department-dropdown-container">
                        <Autocomplete
                          disabled
                          multiple
                          disableCloseOnSelect
                          popupIcon={<KeyboardArrowDownIcon className="audience-vertical-dropdown-icon" />}
                          options={[]}
                          value={row.departmentId || []}
                          getOptionLabel={(option) => option?.name || ''}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Box key={option.id || index} component="span" className="audience-vertical-tag">
                                <Box component="span" className="audience-vertical-tag-label">{option.name}</Box>
                              </Box>
                            ))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              disabled
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                sx: {
                                  ...departmentFieldSx['& .MuiOutlinedInput-root'],
                                  padding: '8px 8px !important',
                                  alignItems: 'flex-start',
                                },
                              }}
                              className="audience-vertical-textfield custom-placeholder-style"
                            />
                          )}
                          className="audience-vertical-autocomplete"
                        />
                      </Box>
                    </Box>
                  ))}
                </>
              );
            }}
          />
          <label className="sign-up-tech-session-label-other" style={{ marginBottom: '-20px' }}>
            {SIGNUP_TECH_SESSION.FIELDS.SESSION_TYPE}
          </label>
          <Controller
            name="sessionType"
            control={control}
            render={({ field }) => (
              <SearchDropdown
                {...field}
                disabled
                options={[]}
                value={{ id: 1, name: sessionData?.sessionType }}
                placeholder={SIGNUP_TECH_SESSION.PLACEHOLDER.SESSION_TYPE}
                customCss={disabledDropdownBgCss}
              />
            )}
          />

          {sessionData?.sessionType === "In-Person" && (
            <>
              <label className="sign-up-tech-session-label-other" style={{ marginBottom: '-20px' }}>
                {SIGNUP_TECH_SESSION.FIELDS.LOCATION}
              </label>
              <Controller
                name="location"
                control={control}
                render={({ field }) => (
                  <SearchDropdown
                    {...field}
                    disabled
                    options={[]}
                    value={{ id: 1, name: sessionData?.location }}
                    placeholder={SIGNUP_TECH_SESSION.PLACEHOLDER.LOCATION}
                    customCss={disabledDropdownBgCss}
                  />
                )}
              />
            </>
          )}

          <label className="sign-up-tech-session-label-other">
            {SIGNUP_TECH_SESSION.FIELDS.DESCRIPTION}
          </label>
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <CommonTextField
                {...field}
                disabled
                multiline
                rows={3}
                size="small"
                sx={{
                  ...disabledInputBgSx,
                  '& .MuiOutlinedInput-root': {
                    ...disabledInputBgSx['& .MuiOutlinedInput-root'],
                    padding: 0,
                    overflow: 'hidden',
                    '& textarea': { padding: '8.5px 14px' },
                  },
                }}
              />
            )}
          />

          <div className="sign-up-submit-btn-row" style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
            <ButtonComponent
              label={'Reject'}
              variant="text"
              onClick={handleReject}
              btnCss="cancel-btn"
              disabled={!canApproveReject}
            ></ButtonComponent>

            <ButtonComponent
              label={'Approve'}
              variant="contained"
              onClick={handleApprove}
              btnCss='modal-btn'
              disabled={!canApproveReject}
            ></ButtonComponent>
          </div>
        </form>
      </div>
      <ActionConfirmationDialog
        open={isDialogOpen}
        title={title}
        description={description}
        button2Text={buttonText}
        onCancel={onPopupCancel}
        setComments={setComments}
        comments={comments}
        handleApproveOrReject={() => approveOrRejectTechSession()}
      />
    </div>
  );
};

export default ApproveRejectForm;